import env from '@framework/env/env';

const gaConfig = {
  linkerDomains: env('GA__LINKER_DOMAINS')?.split(','),
};

export default gaConfig;
